import type { ReactNode } from 'react'

type DataTableProps = {
  minWidthClassName: string
  headerRow: ReactNode
  children: ReactNode
  tableLayout?: 'fixed' | 'auto'
}

export function DataTable({
  minWidthClassName,
  headerRow,
  children,
  tableLayout = 'fixed',
}: DataTableProps) {
  return (
    <table
      className={`${minWidthClassName} w-full ${tableLayout === 'auto' ? 'table-auto' : 'table-fixed'} text-left text-[10px] text-ink sm:text-xs`}
    >
      <thead className="bg-surface/70 text-[9px] font-semibold text-muted sm:text-[10px]">
        {headerRow}
      </thead>
      <tbody>{children}</tbody>
    </table>
  )
}

type DataTableMessageRowProps = {
  colSpan: number
  message: string
}

export function DataTableMessageRow({
  colSpan,
  message,
}: DataTableMessageRowProps) {
  return (
    <tr className="border-t border-border/60 bg-white">
      <td
        colSpan={colSpan}
        className="px-4 py-10 text-center text-[11px] text-muted sm:text-sm"
      >
        {message}
      </td>
    </tr>
  )
}
